import React from "react";

// Re-export the federation enum so callers stay nominally compatible
// with values coming out of generated GraphQL types. Previously this
// module declared its own `InvoiceStatus` enum with the same values,
// which TS treated as a distinct nominal type and forced casts at
// every boundary.
export { InvoiceStatus } from "elephant-web/gql";

export enum InvoiceFilterStatus {
  ALL = "ALL",
  PAID = "PAID",
  PENDING = "PENDING",
  UNPAID = "UNPAID",
  REFUNDED = "REFUNDED",
  VOID = "VOID",
}

export interface InvoiceFiltersProps {
  input: InvoiceFiltersProps;
  setInput: SetInputFunction;
}

export type InvoiceFilterInput = {
  start: string;
  end: string;
  invoiceStatus: InvoiceFilterStatus;
};

export type SetInputFunction = React.Dispatch<
  React.SetStateAction<InvoiceFilterInput>
>;
